<template></template>

<script>
import ModalWrapper from "./ModalWrapper.vue";

export default {
    name: "PopUpTrigger",

    props: {
        garageUrl: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            whoAreYouText: window.Drupal.t('Who are you?'),
        }
    },

    mounted() {
        this.checkPopup()
    },

    methods: {
        checkPopup() {
            if (localStorage.getItem('repair-shop')) {
                return
            }

            this.$modal.show(ModalWrapper, {
                props: {
                    garageUrl: this.garageUrl,
                    id: 'who-are-you-modal',
                    label: `${this.whoAreYouText} modal`
                }
            })
        }
    }
}
</script>